/** Email-code resend waits use the shared wall clock, including after a suspended tab wakes. */
import { useNowSeconds } from '../utils/use-now-seconds';

import { resendSeconds } from '../utils/resend-seconds';

export function useResendCountdown(deadline: Date | null): number {
  return resendSeconds(deadline, useNowSeconds(deadline !== null));
}
